import { useMemo, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/counter.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "./PropertyImagesCarousel.scss";

import CldImage, { cldUrl } from "../../lib/cloudinary.jsx";

const NOT_FOUND_ID = "properties/imgNotFound_zodsam";

const FULL_TRANSFORMS = [
  ["w", "1600"],
  ["c", "limit"],
  ["q", "auto"],
  ["f", "auto"],
];

// In-page gallery tiles. Capped so the grid never pulls the original upload.
const GRID_TRANSFORMS = [
  ["w", "1200"],
  ["c", "limit"],
];

const PropertyImagesCarousel = ({ images }) => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const slides = useMemo(
    () =>
      (images || []).map((img) => {
        const publicId = img?.public_id || NOT_FOUND_ID;
        return {
          src: cldUrl(publicId, FULL_TRANSFORMS),
          alt: publicId,
        };
      }),
    [images]
  );

  if (!images || !images.length) return null;

  return (
    <>
      <div className='property-gallery'>
        {images.map((slide, i) => (
          <a
            href={
              slide.url || cldUrl(slide.public_id || NOT_FOUND_ID, FULL_TRANSFORMS)
            }
            key={slide.public_id || i}
            onClick={(e) => {
              e.preventDefault();
              setIndex(i);
              setOpen(true);
            }}
          >
            <CldImage
              publicId={slide.public_id || NOT_FOUND_ID}
              transforms={GRID_TRANSFORMS}
              alt={slide.public_id || "Image not found"}
            />
          </a>
        ))}
      </div>
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        index={index}
        on={{ view: ({ index: i }) => setIndex(i) }}
        slides={slides}
        plugins={[Thumbnails, Zoom, Fullscreen, Slideshow, Counter]}
        thumbnails={{ position: "bottom", width: 100, height: 80, gap: 4 }}
        carousel={{ finite: false, padding: 0 }}
        animation={{ fade: 250 }}
      />
    </>
  );
};

export default PropertyImagesCarousel;
